import { createSlice } from "@reduxjs/toolkit";

export interface InitialStateSlice {
  value: number;
}

const initialState: InitialStateSlice = {
  value: 0,
};

const CreateDispatchStepSlice = createSlice({
  name: "createDispatchStep",
  initialState,
  reducers: {
    nextDispatchOrderPage: (state) => {
      state.value += 1;
    },
    prevDispatchOrderPage: (state) => {
      state.value -= 1;
    },
    resetDispatchOrderStep: (state) => {
      state.value = 0;
    },
  },
});

export const {
  nextDispatchOrderPage,
  prevDispatchOrderPage,
  resetDispatchOrderStep,
} = CreateDispatchStepSlice.actions;
export default CreateDispatchStepSlice.reducer;
